<div class="banner">
  <div class="bg"></div>
  <div class="city"></div>

  <div class="content">
    <div class="title-container">
      <div class="supra-title">BUY</div>
      <div class="title">
        <img src="./assets/img/promotions/logo.png" width="180" />
      </div>
    </div>

    <div class="footer-container">
      <div class="footer-text">with your credit card</div>
      <button appButton class="download-button medium solid warn" (click)="goToApplication()">
        Buy
      </button>
    </div>
  </div>
</div>
